import api from "../instance/axios_instance.ts";
import { UserInterface } from "../interface/userInterface.ts";

const InfoUserApi = async (): Promise<UserInterface> => {

    try {
        const response = await api.get<UserInterface>('/user_info' ); 
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        return Promise.reject(mensajeError || 'Error al obtener la información del usuario');
    }

}

export default InfoUserApi;